import React from 'react';
import { Button } from '@/components/ui/button';
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SettingsToggleButtonProps {
  showSettings: boolean;
  onToggle: () => void;
  isMobile: boolean;
  targetId: string; // aria-controls target
  labels?: {
    hide?: string;
    show?: string;
  };
  className?: string;
}

export const SettingsToggleButton: React.FC<SettingsToggleButtonProps> = ({
  showSettings,
  onToggle,
  isMobile,
  targetId,
  labels = {},
  className
}) => {
  const hideLabel = labels.hide ?? 'Ẩn Cấu Hình';
  const showLabel = labels.show ?? 'Hiện Cấu Hình';

  return (
    <Button
      onClick={onToggle}
      variant="outline"
      size="sm"
      className={cn('gap-2', className)}
      aria-expanded={showSettings}
      aria-controls={targetId}
      title={showSettings ? hideLabel : showLabel}
    >
      {showSettings ? (
        <>
          <PanelLeftClose className="h-4 w-4" />
          {!isMobile && <span>{hideLabel}</span>}
        </>
      ) : (
        <>
          <PanelLeftOpen className="h-4 w-4" />
          {!isMobile && <span>{showLabel}</span>}
        </>
      )}
    </Button>
  );
};
